import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputDate, InputTextArea} from '../../../../../../components/UI/Input'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {getSite, getClient, getCamp, getMasterService} from '../../../../services'
import {CampModel, SiteModel, ClientModel, ModuleModel} from '../../../../model'
import {getClaims} from '../../../../services/claimUser.service'
import {useCentral} from '../../../../../../hooks/useCentral'
import {SelectModel} from '../../../../../lavanderia/model'
import moment from 'moment'
import {getClaimById} from '../../../../services/claimUser.service'
import {formatDate} from '../../../../../../util/dates'
import {SnackbarProvider} from 'notistack'
import {useAuth} from '../../../../../../hooks/useAuth'
import {useCompany} from '../../../../hooks'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_CLAIM_USER} from '../../../../util/Constants'
const Index: FC = () => {
  const {
    setError,
    register,
    formState: {errors},
    setValue,
  } = useFormContext()
  const {applications} = useAuth()
  const {companyList, getCompanyList} = useCompany()
  const mappedSites = applications.map((item: any) => ({
    value: item.aplicacionId,
    label: item.description,
  }))

  const {currentTabItem} = useCentral()
  const [site, setSite] = useState<SiteModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [camp, setCamp] = useState<SelectModel[]>([])
  const [requerimentTypes, setRequerimentTypes] = useState<SelectModel[]>([])
  const [claim, setClaim] = useState<ModuleModel[]>([])
  const [isClaimant, setIsClaimant] = useState<boolean>(false)

  const getClaimList = async () => {
    const response = await getClaims({}, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.Id, label: 'N° ' + item.nroRequerimiento}))
    setClaim(mappedSites)
  }
  const getSiteList = async (valCli: any, val: any) => {
    let obj: SiteModel = {
      isCombo: true,
      clienteId: valCli,
      id: val,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }

  const getClientList = async (valcom: any, val: any) => {
    let obj: ClientModel = {
      isCombo: true,
      companiaId: valcom,
      id: val,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }
  const getCampList = async (valSite: any, val: any) => {
    let obj: CampModel = {
      isCombo: true,
      siteId: valSite,
      id: val,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getClaimById(idToEdit as any)
        const {
          Id,
          companiaId,
          clienteId,
          siteId,
          campamentoId,
          tipoRequerimientoId,
          aplicacionId,
          fechaRequerimiento,
          reclamanteId,
          CodigoReclamoId,
          reclamo,
          usuarioNombres,
          usuarioEmpresa,
          usuarioTelefono,
          usuarioEmail,
          campoadicionaltxt1,
          campoadicionaltxt2,
          campoadicionaltxt3,
          campoadicionaltxt4,
          campoadicionaltxt5,
          campoadicionalnum1,
          campoadicionalnum2,
          campoadicionalnum3,
          campoadicionalFec1,
          campoadicionalFec2,
        } = data
        setValue('Id', Id)
        setValue('companiaId', companiaId)
        setValue('clienteId', clienteId)
        setValue('siteId', siteId)
        setValue('campamentoId', campamentoId)
        setValue('tipoRequerimientoId', tipoRequerimientoId)
        setValue('aplicacionId', aplicacionId)
        setValue('reclamanteId', reclamanteId)
        setValue('CodigoReclamoId', CodigoReclamoId)
        setValue('usuarioNombres', usuarioNombres)
        setValue('usuarioEmpresa', usuarioEmpresa)
        setValue('usuarioTelefono', usuarioTelefono)
        setValue('usuarioEmail', usuarioEmail)
        setValue('campoadicionaltxt1', campoadicionaltxt1)
        setValue('campoadicionaltxt2', campoadicionaltxt2)
        setValue('campoadicionaltxt3', campoadicionaltxt3)
        setValue('campoadicionaltxt4', campoadicionaltxt4)
        setValue('campoadicionaltxt5', campoadicionaltxt5)
        setValue('fechaRequerimiento', formatDate(fechaRequerimiento))
        let num1 = campoadicionalnum1 ? (campoadicionalnum1 === 0 ? '' : campoadicionalnum1) : ''
        let num2 = campoadicionalnum2 ? (campoadicionalnum2 === 0 ? '' : campoadicionalnum2) : ''
        let num3 = campoadicionalnum3 ? (campoadicionalnum3 === 0 ? '' : campoadicionalnum3) : ''
        setIsClaimant(true)
        setValue('campoadicionalnum1', num1)
        setValue('campoadicionalnum2', num2)
        setValue('campoadicionalnum3', num3)
        setValue('campoadicionalFec1', campoadicionalFec1)
        setValue('campoadicionalFec2', campoadicionalFec2)
        setValue('reclamo', reclamo)
        getClientList(companiaId as any, '')
        getSiteList(clienteId as any, '')
        getCampList(siteId as any, '')
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getClaimId()
    }
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    getCompanyList()
    getClaimList()
    getRequerimentTypes()
  }, [])

  const getRequerimentTypes = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRequerimentTypes(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de requerimientos:', error)
    }
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientList(value, '')
    setValue('companiaId', value)
    setError('companiaId', {})
  }
  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSiteList(value, '')
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleGetCampList = async (val: any) => {
    let value = val ? val.value : ''
    getCampList(value, '')
    setValue('siteId', value)
    setError('siteId', {})
  }

  return (
    <ContentForm title={TITLE_FORM_CLAIM_USER}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={companyList}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
            required
          />
        </div>

        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={client}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={site}
            disabled={isDisabled}
            onChangeValue={handleGetCampList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={camp}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de Requerimiento'
            name='tipoRequerimientoId'
            data={requerimentTypes}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Módulo'
            name='aplicacionId'
            data={mappedSites}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Fecha de Reclamo:</label>
          <InputDate
            name='fechaRequerimiento'
            register={register}
            errors={errors}
            minValue='1900-01-01'
            defaultValue={moment().format('YYYY-MM-DD')}
            disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Reclamos precedente'
            name='CodigoReclamoId'
            data={claim}
            disabled={isDisabled}
          />
        </div>

        {isClaimant && (
          <>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper
                labelText='Nombres del reclamante'
                name='usuarioNombres'
                disabled
                required
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Empresa del usuario' name='usuarioEmpresa' disabled />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Teléfono del usuario' name='usuarioTelefono' disabled />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Email del usuario' name='usuarioEmail' disabled />
            </div>
          </>
        )}
      </div>
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <label className='required'>Reclamo:</label>
          <InputTextArea
            name='reclamo'
            textPlaceholder='Escribe el reclamo'
            register={register}
            errors={errors}
            disabled={isDisabled}
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
      <SnackbarProvider />
    </ContentForm>
  )
}

export default Index
